module.exports = __webpack_public_path__ + "static/nassim-nicholas-taleb-04760bc1024ca156078c76317040b0b6.jpg";